import DetailsTable, { DetailsRow } from '../../common/details-table';
import { Match } from './utils/data';
import { useStringsContext } from '../../../contexts/strings';
import Typography from '@mui/material/Typography';

export default function MatchStats({ matchDoc }: { matchDoc: Match }) {
  const { strings } = useStringsContext();

  if (!matchDoc.stats) {
    return (
      <Typography variant="body1" sx={{ padding: '16px', textAlign: 'center' }}>
        {strings.matches.statsMissing}
      </Typography>
    );
  }

  const details = [
    {
      label: strings.matches.homeCorners,
      value: matchDoc.stats.homeCorners,
    },
    {
      label: strings.matches.homeFinishes,
      value: matchDoc.stats.homeFinishes,
    },
    {
      label: strings.matches.homeFreeKicks,
      value: matchDoc.stats.homeFreeKicks,
    },
    {
      label: strings.matches.homeOffsides,
      value: matchDoc.stats.homeOffsides,
    },
    {
      label: strings.matches.homeRedCards,
      value: matchDoc.stats.homeRedCards,
    },
    {
      label: strings.matches.homeShotsOnGoal,
      value: matchDoc.stats.homeShotsOnGoal,
    },
    {
      label: strings.matches.homeSubstitutions,
      value: matchDoc.stats.homeSubstitutions,
    },
    {
      label: strings.matches.homeYellowCards,
      value: matchDoc.stats.homeYellowCards,
    },
    {
      label: strings.matches.visitingCorners,
      value: matchDoc.stats.visitingCorners,
    },
    {
      label: strings.matches.visitingFinishes,
      value: matchDoc.stats.visitingFinishes,
    },
    {
      label: strings.matches.visitingFreeKicks,
      value: matchDoc.stats.visitingFreeKicks,
    },
    {
      label: strings.matches.visitingOffsides,
      value: matchDoc.stats.visitingOffsides,
    },
    {
      label: strings.matches.visitingRedCards,
      value: matchDoc.stats.visitingRedCards,
    },
    {
      label: strings.matches.visitingShotsOnGoal,
      value: matchDoc.stats.visitingShotsOnGoal,
    },
    {
      label: strings.matches.visitingSubstitutions,
      value: matchDoc.stats.visitingSubstitutions,
    },
  ] satisfies DetailsRow[];

  return <DetailsTable rows={details} />;
}
